import React from "react"
import propTypes from "prop-types"

const Label = ({ label, htmlFor }) => {
  return (
    <label className="form_label" htmlFor={htmlFor}>
      {label}
    </label>
  )
}

Label.propTypes = {
  label: propTypes.string.isRequired,
  htmlFor: propTypes.string.isRequired
}

export default Label
